import React, { useState, useEffect, useRef } from "react";
import FolderIcon from "./img/folder.webp";
import FolderSVGIcon from "./img/folderIcon.svg";
import { Button, Form, Row, Col, Modal, Alert } from "react-bootstrap";
import { useConfig } from "./ConfigContext";
export default function KachelDateiMenu({
   kachelData,
   user,
   handleElementBlock,
   currentElement,
   blockedField,
   sharepointObject,
   sharepointIDs,
   loadSharepointData,
   sendCommentsandNotes,
   loading,
}) {
   const config = useConfig();
   const [showThumbnail, setShowThumbnail] = useState(false);
   const [freigeben, setFreigeben] = useState();
   const [showFiles2, setShowFiles2] = useState(false);
   const [newFile2, setNewFile2] = useState(false);
   const [file2, setFile2] = useState({});
   const [fileEditIndex2, setFileEditIndex2] = useState(false);
   const [expandedFolder, setExpandedFolder] = useState();
   const [layeredSharepointObject, setLayeredSharepointObject] = useState([]);

   useEffect(() => {
      if (sharepointObject) {
         const newLayeredList = structuredClone(sharepointObject);
         Object.keys(newLayeredList).forEach((item) => {
            /* console.log(item);
            console.log(sharepointObject[item]);
            console.log(newLayeredList); */

            if (sharepointObject[item].parentFolder && newLayeredList[sharepointObject?.[item]?.parentReference?.id]) {
               newLayeredList[sharepointObject[item].parentReference.id]["children"] = {
                  ...(newLayeredList[sharepointObject[item].parentReference.id]?.["children"] ?? {}),
                  [item]: sharepointObject[item],
               };
               delete newLayeredList[item];
            }
         });
         setLayeredSharepointObject(newLayeredList);
      }
   }, [sharepointObject]);

   function closeModal() {
      setShowFiles2(false);
      handleElementBlock(false, config.estate.sharepointIds, sharepointIDs);
   }

   return (
      <>
         <button
            className="share-button"
            disabled={false}
            style={blockedField[config.estate.sharepointIds] ? { opacity: 1, outline: "solid 6px #f0a" } : {}}
            title="Dateien anzeigen/verbergen"
            onClick={(e) => {
               e.preventDefault();
               setShowFiles2(true);
            }}
         >
            <img src={FolderIcon} />
            {blockedField[config.estate.sharepointIds] ? (
               <span style={{ backgroundColor: "#f0a" }}>{blockedField[config.estate.sharepointIds].user.Kuerzel}</span>
            ) : (
               <>
                  {sharepointIDs && sharepointIDs[kachelData.kachelId] && sharepointIDs[kachelData.kachelId].length && (
                     <span>{sharepointIDs[kachelData.kachelId].length}</span>
                  )}
               </>
            )}
         </button>

         <Modal show={showFiles2} size="xl" className="" onHide={() => closeModal()}>
            <Modal.Header closeButton>
               <h3>
                  <img className="me-3" src={FolderIcon} height={36} />
                  Dateien
                  {blockedField[config.estate.sharepointIds] && (
                     <small style={{ color: "#f0a" }}>
                        {" "}
                        ... wird aktuell bearbeitet von {blockedField[config.estate.sharepointIds].user.Name}
                     </small>
                  )}
               </h3>
            </Modal.Header>
            <Modal.Body>
               <div
                  onClick={() => {
                     console.log("click");
                     if (!currentElement.element || currentElement.element !== config.estate.sharepointIds) {
                        handleElementBlock(true, config.estate.sharepointIds, sharepointIDs);
                     }
                  }}
                  className="kachel-notizbereich"
                  style={
                     blockedField[config.estate.sharepointIds]
                        ? { pointerEvents: "none", opacity: 0.9, filter: "saturate(0)" }
                        : {}
                  }
               >
                  <h4>Sharepoint Dateien</h4>

                  {sharepointIDs && sharepointIDs[kachelData.kachelId] && (
                     <div className="kachel-dateien">
                        {sharepointIDs[kachelData.kachelId].map((datei, index) => {
                           return (
                              <React.Fragment key={"keySP_" + index}>
                                 {sharepointObject && sharepointObject[datei.name] ? (
                                    <div
                                       className="kachel-datei"
                                       style={datei.public2 ? { backgroundColor: "#090" } : {}}
                                    >
                                       {
                                          <img
                                             onClick={() => {
                                                setShowThumbnail((prev) => (prev === index ? false : index));
                                             }}
                                             style={{
                                                backgroundColor: "#fff",
                                                marginRight: "4px",
                                                padding: "2px",
                                                borderRadius: "8px",
                                                transition: "all 0.2s",
                                                cursor: "pointer",
                                             }}
                                             src={
                                                sharepointObject[datei.name].thumbnails.length
                                                   ? showThumbnail === index
                                                      ? sharepointObject[datei.name].thumbnails[0].large.url
                                                      : sharepointObject[datei.name].thumbnails[0].small.url
                                                   : FolderSVGIcon
                                             }
                                             height={showThumbnail === index ? "" : "96"}
                                             width={showThumbnail === index ? "100%" : "96"}
                                          />
                                       }

                                       <a
                                          target="_blank"
                                          className="kachel-datei-link"
                                          style={showThumbnail === index ? { width: "100%", marginTop: "4px" } : {}}
                                          href={sharepointObject[datei.name].webUrl}
                                       >
                                          <span>
                                             {sharepointObject[datei.name].folder && "🗁 "}{" "}
                                             {sharepointObject[datei.name].parentFolder &&
                                                "🗁 " + sharepointObject[datei.name].parentFolder + " | "}{" "}
                                             {sharepointObject[datei.name].name}
                                          </span>
                                          <small style={{ display: "block", fontSize: "12px" }}>
                                             {new Date(datei.timestamp).toLocaleString()} von {datei.user}
                                          </small>
                                       </a>
                                       {!(showThumbnail === index) && (
                                          <button
                                             title="Dateiverlinkung entfernen (Datei im Sharepoint bleibt erhalten)"
                                             disabled={loading === "loading"}
                                             onClick={async () => {
                                                await sendCommentsandNotes(
                                                   "sharepoint",
                                                   kachelData.kachelId,
                                                   false,
                                                   index,
                                                );
                                             }}
                                          >
                                             ×
                                          </button>
                                       )}
                                    </div>
                                 ) : (
                                    <div className="kachel-datei">
                                       <div
                                          style={{
                                             display: "inline-block",
                                             outline: "solid 6px #c00",
                                             width: "calc(100% - 96px - 22px)",
                                             margin: "10px",
                                             padding: "10px",
                                             height: "100%",
                                          }}
                                          title="Fehlerhafter Link! Möglicherweise wurde die verlinkte Datei aus dem Sharepoint ersetzt oder entfernt."
                                       >
                                          Fehlerhafter Link! Möglicherweise wurde die verlinkte Datei aus dem Sharepoint
                                          ersetzt oder entfernt. ID: {datei.name}
                                       </div>
                                       <button
                                          title="Dateiverlinkung entfernen (Datei im Sharepoint bleibt erhalten)"
                                          disabled={loading === "loading"}
                                          onClick={async () => {
                                             await sendCommentsandNotes(
                                                "sharepoint",
                                                kachelData.kachelId,
                                                false,
                                                index,
                                             );
                                          }}
                                       >
                                          ×
                                       </button>
                                    </div>
                                 )}
                              </React.Fragment>
                           );
                        })}
                     </div>
                  )}

                  {!newFile2 && (
                     <Button
                        variant="primary"
                        // style={{ width: "200px" }}
                        onClick={() => setNewFile2(true)}
                     >
                        + Neue Datei
                     </Button>
                  )}

                  {newFile2 && (
                     <>
                        <hr />
                        <Row>
                           {layeredSharepointObject && (
                              <>
                                 <h4>Neue Dateien </h4>
                                 <ul className="filelist">
                                    {Object.keys(layeredSharepointObject).map((item) => {
                                       if (layeredSharepointObject[item]) {
                                          return (
                                             <>
                                                {layeredSharepointObject[item].folder ? (
                                                   <li
                                                      key={"splist_" + layeredSharepointObject[item].id}
                                                      style={
                                                         file2[item] ? { backgroundColor: "#224b", color: "#fff" } : {}
                                                      }
                                                      onClick={() => {
                                                         console.log(file2);
                                                         console.log(item);
                                                         console.log(expandedFolder);
                                                         console.log(layeredSharepointObject[item]);

                                                         setExpandedFolder((prev) => (item === prev ? false : item));
                                                      }}
                                                   >
                                                      <span>
                                                         <img src={FolderSVGIcon} height="22" alt=" 🗁 " />
                                                         {layeredSharepointObject[item].name}
                                                      </span>

                                                      {layeredSharepointObject[item].children &&
                                                         expandedFolder === item && (
                                                            <ul
                                                               style={{
                                                                  boxShadow: "inset 0 0px 10px #2244",
                                                                  borderRadius: "8px",
                                                               }}
                                                            >
                                                               <li
                                                                  style={{
                                                                     display: "flex",
                                                                     flexDirection: "row",
                                                                     justifyContent: "space-between",
                                                                     ...(file2[item]
                                                                        ? { backgroundColor: "#224b", color: "#fff" }
                                                                        : {}),
                                                                  }}
                                                               >
                                                                  <span>
                                                                     <img src={FolderSVGIcon} height="22" alt=" 🗁 " />
                                                                     {layeredSharepointObject[item].name}
                                                                  </span>
                                                                  <div
                                                                     className="w-25"
                                                                     onClick={(e) => {
                                                                        e.stopPropagation();
                                                                     }}
                                                                  >
                                                                     {file2[item] ? (
                                                                        <Button
                                                                           className="w-100"
                                                                           onClick={() => {
                                                                              setFile2((prev) => ({
                                                                                 ...prev,
                                                                                 [item]: false,
                                                                              }));
                                                                           }}
                                                                           variant="outline-light"
                                                                           style={{ backgroundColor: "#0005" }}
                                                                        >
                                                                           Ordner abwählen
                                                                        </Button>
                                                                     ) : (
                                                                        <Button
                                                                           className="w-100"
                                                                           variant="outline-dark"
                                                                           onClick={() => {
                                                                              setFile2((prev) => ({
                                                                                 ...prev,
                                                                                 [item]: {
                                                                                    active: true,
                                                                                    public2: false,
                                                                                 },
                                                                              }));
                                                                           }}
                                                                        >
                                                                           Ordner hinzufügen
                                                                        </Button>
                                                                     )}
                                                                  </div>
                                                               </li>
                                                               {Object.keys(layeredSharepointObject[item].children).map(
                                                                  (childitem) => (
                                                                     <CheckFreigabe
                                                                        name={
                                                                           layeredSharepointObject[item].children[
                                                                              childitem
                                                                           ].name
                                                                        }
                                                                        file2={file2}
                                                                        item={childitem}
                                                                        setFile2={setFile2}
                                                                        freigeben={freigeben}
                                                                        setFreigeben={setFreigeben}
                                                                     />
                                                                  ),
                                                               )}
                                                            </ul>
                                                         )}
                                                   </li>
                                                ) : (
                                                   <CheckFreigabe
                                                      key={"splist_" + layeredSharepointObject[item].id}
                                                      name={layeredSharepointObject[item].name}
                                                      file2={file2}
                                                      item={item}
                                                      setFile2={setFile2}
                                                      freigeben={freigeben}
                                                      setFreigeben={setFreigeben}
                                                   />
                                                )}
                                             </>
                                          );
                                       }
                                    })}
                                 </ul>
                              </>
                           )}
                        </Row>
                        <Button
                           variant="dark"
                           disabled={loading === "loading"}
                           onClick={async () => {
                              await sendCommentsandNotes(
                                 "sharepoint",
                                 kachelData.kachelId,
                                 Object.keys(file2)
                                    .filter((filekey) => file2[filekey])
                                    .map((fileitem) => ({
                                       name: fileitem,
                                       timestamp: new Date().toISOString(),
                                       user: user.Name,
                                       public2: file2[fileitem].public2,
                                    })),
                              );
                              setFile2({});
                              setNewFile2(false);
                           }}
                        >
                           Speichern
                        </Button>
                        <Button
                           title="Wenn eine Datei neu in den Sharepoint geladen wurde und noch nicht in der Liste auftaucht hier klicken um zu aktualisieren."
                           onClick={() => loadSharepointData()}
                           variant="outline-secondary"
                           className="ms-1"
                        >
                           ⟳
                        </Button>
                     </>
                  )}
               </div>
            </Modal.Body>
         </Modal>
      </>
   );
}

function CheckFreigabe({ name, item, file2, setFile2, freigeben, setFreigeben }) {
   return (
      <li
         style={{
            ...(freigeben === item
               ? {}
               : {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                 }),
            ...(file2[item]
               ? {
                    backgroundColor: file2[item].public2 ? "#090c" : "#224c",
                    color: "#fff",
                 }
               : {}),
         }}
         onClick={(e) => {
            e.stopPropagation();
         }}
      >
         <span>{name}</span>
         {freigeben === item ? (
            <div style={{ width: "100%" }}>
               <Alert
                  variant="danger"
                  onClick={(e) => {
                     e.stopPropagation();
                  }}
               >
                  <h3>Muss die Datei für einen möglichen Versand an Kunden ggf. noch geschwärzt werden?</h3>
                  <p>
                     Wenn nicht, habe ich sichergestellt, dass in dem Dokument alle personenbezogenen Daten (Namen,
                     Adressen, Geburtsdaten usw.) unkenntlich gemacht wurden.
                  </p>
                  <div
                     style={{
                        backgroundColor: "#58151C00",
                        borderRadius: "16px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                     }}
                  >
                     <Button
                        variant="light"
                        style={{ boxShadow: "0 0 10px #0004" }}
                        className="m-2 w-50"
                        onClick={(e) => {
                           setFile2((prev) => {
                              console.log(prev);

                              return {
                                 ...prev,
                                 [item]: { active: true, public2: false },
                              };
                           });
                           setFreigeben(false);
                        }}
                     >
                        Ja bzw. ist nur für intern
                     </Button>
                     <Button
                        variant="danger"
                        className="m-2 w-50"
                        style={{ boxShadow: "0 0 10px #0004" }}
                        onClick={(e) => {
                           setFile2((prev) => {
                              console.log(prev);

                              return {
                                 ...prev,
                                 [item]: { active: true, public2: true },
                              };
                           });
                           setFreigeben(false);
                        }}
                     >
                        Nein, ist geprüft und darf an Kunden versendet werden
                     </Button>
                  </div>
               </Alert>
            </div>
         ) : (
            <div
               className="w-25"
               onClick={(e) => {
                  e.stopPropagation();
               }}
            >
               {file2[item] ? (
                  <Button
                     className="w-100"
                     onClick={() => {
                        setFile2((prev) => ({
                           ...prev,
                           [item]: false,
                        }));
                     }}
                     variant="outline-light"
                     style={{ backgroundColor: "#0005" }}
                  >
                     Datei abwählen
                  </Button>
               ) : (
                  <Button className="w-100" variant="outline-dark" onClick={() => setFreigeben(item)}>
                     Datei hinzufügen
                  </Button>
               )}
            </div>
         )}
      </li>
   );
}
